import { Box, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import zeplinColor from 'theme/Color';

const formatNumber = (num: number): string => {
  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(2)}B`;
  } else if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(2)}M`;
  } else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(2)}k`;
  }
  return num.toString();
};
const Chart = ({ data, loading }: { data: any; loading: boolean }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  const transformedValue =
    (Object.keys(data)?.length &&
      Object.entries(data || {}).map(([key, value]: any) => ({ platform: key, count: value }))) ||
    [];
  console.log({ data, transformedValue });
  const platformColors = [
    zeplinColor.Blue4,
    '#F3A03F',
    '#8F42EB',
    '#45C7EB',
    '#DD67F0',
    '#2BDF89',
    zeplinColor.USER_PROFILE_COLOR1,
    zeplinColor.USER_PROFILE_COLOR2,
    zeplinColor.USER_PROFILE_COLOR3,
    zeplinColor.USER_PROFILE_COLOR4,
    zeplinColor.USER_PROFILE_COLOR5,
    zeplinColor.USER_PROFILE_COLOR6,
    zeplinColor.USER_PROFILE_COLOR7,
  ];
  return (
    <Box
      sx={{
        flex: 1,
        borderRadius: '14px',
        padding: { xs: '12px 16px 16px 16px', xl: '24px 16px 16px 16px' },
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',

        overflowY: 'auto',
        position: 'relative',
      }}
    >
      {' '}
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <Skeleton variant='circular' width={200} height={200} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',

              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '8rem',
              }}
            />
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '8rem',
              }}
            />
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '8rem',
              }}
            />
          </Box>
        </Box>
      ) : transformedValue?.length > 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          <Box
            sx={{
              position: 'relative',
            }}
          >
            {transformedValue?.length > 0 && (
              <PieChart
                sx={{ height: { xs: '12rem', xl: '15rem' }, position: 'relative', left: '25%' }}
                hideLegend={true}
                series={[
                  {
                    data: transformedValue?.map((item: any, index: any) => ({
                      id: index,
                      value: item.count,
                      label: item.platform.charAt(0).toUpperCase() + item.platform.slice(1),
                      color: platformColors[index],
                    })),
                    innerRadius: isXs ? 80 : isXl ? 90 : 80,
                    paddingAngle: 2,
                    cornerRadius: 3,
                    cx: 110,
                  },
                ]}
              />
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              justifyContent: 'center',
            }}
          >
            {transformedValue?.map((val: any, ind: number) => (
              <Box
                sx={{
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: platformColors[ind],
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    gap: '42px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography variant='responsiveBody3' sx={{ width: '8rem' }}>
                    {val?.platform.charAt(0).toUpperCase() + val?.platform.slice(1)}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '4px',
                      alignItems: 'center',

                      justifyContent: 'flex-end',
                    }}
                  >
                    <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
                      {formatNumber(val?.count)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: '42%',
            margin: 'auto',
            display: 'flex',
            backgroundColor: zeplinColor.Neutral1,
            flexDirection: 'column',
            gap: '24px',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={'/assets/no-chart.svg'} width={'36px'} height={'36px'} alt='no-chart' />
          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant='responsiveHeading3'>No Data Available</Typography>
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
              There’s no data to display right now. Data will appear here automatically once
              available.
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Chart;
